import ScrollReveal from '@/components/base/ScrollReveal';

export default function CookiePolicyPage() {
  return (
    <main className="min-h-screen bg-background-50 pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
            Cookie Policy
          </h1>
          <p className="text-sm text-foreground-500 mb-8">
            Last updated: July 5, 2026
          </p>
        </ScrollReveal>

        <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              1. What Are Cookies?
            </h2>
            <p>
              Cookies are small text files placed on your device when you visit joviaa.in. They help the website remember your preferences, understand how you interact with the site, and provide a more personalised shopping experience. Cookies may be session-based (deleted when you close your browser) or persistent (remain until they expire or you delete them).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              2. Types of Cookies We Use
            </h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Essential Cookies:</strong> Required for the website to function properly. These enable core features like page navigation, shopping cart functionality, checkout process, and secure login. The website cannot operate without these cookies.
              </li>
              <li>
                <strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous information about pages visited, time spent, navigation patterns, and product views. We use this data to improve our site, product offerings, and user experience.
              </li>
              <li>
                <strong>Functional Cookies:</strong> Remember choices you make — such as language preferences, region, recently viewed items, and cart contents — to provide enhanced, more personalised features during your shopping journey.
              </li>
              <li>
                <strong>Marketing Cookies:</strong> Track your browsing habits to deliver advertisements that are relevant to you. These may be set by third-party advertising partners and help us show you Joviaa promotions on platforms like Instagram and Facebook.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              3. Third-Party Cookies
            </h2>
            <p>
              Some cookies on our website are placed by trusted third-party services we use to operate joviaa.in. These include:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Google Analytics:</strong> Helps us analyse website traffic and user behaviour across India.
              </li>
              <li>
                <strong>Social Media Plugins:</strong> Allow you to share content and interact with our Instagram and YouTube pages.
              </li>
              <li>
                <strong>Payment Gateways:</strong> Enable secure online transactions via UPI, cards, and net banking.
              </li>
              <li>
                <strong>Advertising Platforms:</strong> Used to measure the effectiveness of our digital marketing campaigns.
              </li>
            </ul>
            <p className="mt-2">
              These third parties have their own privacy and cookie policies, which we encourage you to review.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              4. Managing Cookies
            </h2>
            <p>
              You can control and manage cookies through your browser settings. Most browsers allow you to:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>View and delete existing cookies</li>
              <li>Block all cookies or third-party cookies</li>
              <li>Set preferences for specific websites</li>
              <li>Enable &quot;Do Not Track&quot; signals</li>
            </ul>
            <p className="mt-2">
              Please note that disabling essential cookies may impact the functionality of our website and your ability to place orders, manage your cart, or complete checkout.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              5. Cookie Duration
            </h2>
            <p>
              Session cookies expire when you close your browser. Persistent cookies remain on your device for a set period or until you manually delete them. Our persistent cookies typically expire within 30 days to 12 months, depending on their purpose. Cart and preference cookies generally last for 30 days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              6. Changes to This Policy
            </h2>
            <p>
              We may update this Cookie Policy to reflect changes in our practices or applicable Indian laws such as the Digital Personal Data Protection Act. The latest version will always be available on this page with the effective date clearly stated.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              7. Contact
            </h2>
            <p>
              For questions about our Cookie Policy, reach us at{' '}
              <a href="mailto:hello@joviaa.in" className="text-accent-500 underline">
                hello@joviaa.in
              </a>{' '}
              or WhatsApp +91 96865 43847.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}